export default "__VITE_ASSET__DeAc8trE__"